/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import HighlightBox from "../../Box/HighlightBox/HighlightBox";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import { Typography } from "@mui/material";

type PowerOfAttorneyOutroHintBoxProps = {
  product: AbstractCase;
};

export default function PowerOfAttorneyIntroHighlightBox({ product }: PowerOfAttorneyOutroHintBoxProps) {
  return (
    <HighlightBox textColor={"defaultText"} headline={""}>
      <Typography sx={{ textAlign: "center" }}>
        {product.legalExpenseInsurance ? (
          <>
            <Typography sx={{
              marginBottom: "16px"
            }}>
              Wir prüfen Ihren Fall <strong>kostenlos und unverbindlich</strong> für Sie.
            </Typography>
            <Typography sx={{
              marginBottom: "16px"
            }}>
              Sofern Ihr Unfallgegner den Unfall allein verschuldet hat, werden unsere Rechtsanwaltsgebühren vollständig von dessen KFZ-Haftpflichtversicherung
              getragen. Sollte ein beidseitiges Verschulden des Unfalls vorliegen, kommen auf Sie ebenfalls <strong>keine Kosten</strong> zu, da Sie bei der{" "}
              {product.caseInsurance.insurer?.name} rechtsschutzversichert sind.
            </Typography>
          </>
        ) : (
          <>
            <Typography sx={{
              marginBottom: "16px"
            }}>
              Wir prüfen Ihren Fall <strong>kostenlos und unverbindlich</strong> für Sie!
            </Typography>
            <Typography sx={{
              marginBottom: "16px"
            }}>
              Sofern Ihr Unfallgegner den Unfall allein verschuldet hat, werden unsere Rechtsanwaltsgebühren vollständig von dessen KFZ-Haftpflichtversicherung
              getragen. Sollte ein beidseitiges Verschulden des Unfalls vorliegen, kommen auf Sie <strong>im außergerichtlichen Verfahren</strong> ebenfalls{" "}
              <strong>keinerlei Kosten</strong> zu.
            </Typography>
            <Typography sx={{
              marginBottom: "16px"
            }}>
              Sollte es <strong>außergerichtlich</strong> zu <strong>keiner Einigung</strong> kommen,{" "}
              <strong>
                besprechen wir zunächst erneut Ihre Erfolgswahrscheinlichkeiten und die Kosten, die in einem gerichtlichen Verfahren auf Sie zukommen könnten.
              </strong>{" "}
              Sie können dann entscheiden, ob Sie ein Gerichtsverfahren wünschen oder nicht.
            </Typography>
          </>
        )}
      </Typography>
    </HighlightBox>
  );
}
